// DeliveryFeeValidationSchema.js
import * as Yup from 'yup';

// Define validation rules for all fields
const DeliveryFeeValidationSchema = Yup.object().shape({
  regionType: Yup.string()
    .required("Region type is required.")
    .nullable(),
  
  deliveryType: Yup.string()
    .required("Delivery type is required.")
    .nullable(),

  vehicleType: Yup.string()
    .required("Vehicle type is required.")
    .nullable(),
  
  additionalFee: Yup.number()
    .required("Additional fee is required.")
    .min(0, "Additional fee cannot be negative."),
  
  referralFeeRate: Yup.number()
    .required("Referral fee rate is required.")
    .min(0, "Referral fee rate cannot be negative."),
  
  closingFeeRate: Yup.number()
    .required("Closing fee rate is required.")
    .min(0, "Closing fee rate cannot be negative."),
  
  shippingFeeRate: Yup.number()
    .required("Shipping fee rate is required.")
    .min(0, "Shipping fee rate cannot be negative."),
  
  shippingHandlingFeeFixedRate: Yup.number()
    .required("Shipping handling fee fixed rate is required.")
    .min(0, "Shipping handling fee fixed rate cannot be negative."),
  
  factors: Yup.array()
    .of(Yup.string().required("Factor ID is required."))
    .min(1, "At least one factor must be selected."),
  
  factor: Yup.array().of(
    Yup.object().shape({
      _id: Yup.string().required("Factor ID is required."),
      value: Yup.number().required("Factor value is required.").min(0, "Factor value cannot be negative."),
    })
  ).min(1, "At least one factor is required."),
});

export default DeliveryFeeValidationSchema;
